module.exports = __webpack_public_path__ + "img/resources-bundle.6e5acdbd.png";